import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { gateTitleToHeading } from 'components/documents/access_settings/helper';
import { accessLevelColors } from '../../../../helper/lead_access_levels';

export default function AccessLevelToShow({ isPinned, uniqueId, valueToShow }) {
  function IconWithPotentialTooltip() {
    const iconAttributes = isPinned ? { icon: faThumbtack } : { size: 'xs', icon: faCircle };
    const child = (
      <FontAwesomeIcon
        color={accessLevelColors[valueToShow]}
        style={{ width: '16.25px' }}
        {...iconAttributes}
      />
    );

    if (!isPinned) return <React.Fragment>{child}</React.Fragment>;

    const tooltip = (
      <Tooltip id={`pinned-tooltip-${uniqueId}`}>
        This leads access has been pinned to low. To unpin, edit the leads document progress.
      </Tooltip>
    );

    return <OverlayTrigger overlay={tooltip} placement="bottom">{child}</OverlayTrigger>;
  }

  return (
    <div className="d-flex gap-3 align-items-center">
      {IconWithPotentialTooltip()}
      {gateTitleToHeading(valueToShow)}
    </div>
  );
}

AccessLevelToShow.propTypes = {
  isPinned: PropTypes.bool.isRequired,
  uniqueId: PropTypes.string.isRequired,
  valueToShow: PropTypes.string.isRequired
};
